import axios from "axios";
import api from "../../../../../services/axios";

export const GetRecruiterDashboardSummary = async () => {
  try {
    const res = await api.get("/Employee/RecruitmentReport/dashboard/summary");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const GetRecruiterDashboardAnalytics = async () => {
  try {
    const res = await api.get("/Employee/RecruitmentReport/dashboard/analytics");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};